
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.09 3.401H7.274v4.364h5.818V3.4zM14.547.492H1.455C.655.492 0 1.147 0 1.947v10.182c0 .8.655 1.44 1.455 1.44h13.09c.8 0 1.455-.64 1.455-1.44V1.947c0-.8-.655-1.455-1.454-1.455zm0 11.644H1.455V1.932h13.09v10.204z"}})])
          )
        }
      }
    